import { DefaultValues } from 'react-hook-form';

import {
  CompanyLegalBeneficiary,
  CompanySupposedBeneficiary,
} from '../../../../__generated__/GQL';
import { Gender } from '../../../../common/types';
import {
  BeneficiarySchema,
  BeneficiarySchemaWithEmail,
} from './beneficiarySchema';

function hasInvitation(
  beneficiary: CompanyLegalBeneficiary | CompanySupposedBeneficiary,
): beneficiary is CompanyLegalBeneficiary {
  return 'invitation' in beneficiary;
}
export const formatCompanyBeneficiaryToBeneficiaryFormInput = (
  beneficiary: CompanyLegalBeneficiary | CompanySupposedBeneficiary | null,
): DefaultValues<BeneficiarySchema> => {
  return {
    firstName: beneficiary?.firstName ?? '',
    gender: (beneficiary?.gender ?? undefined) as Gender | undefined,
    isDirector: beneficiary?.isDirector ?? undefined,
    isMajorShareholder: beneficiary?.isMajorShareholder ?? undefined,
    lastName: beneficiary?.lastName ?? '',
  };
};

export const formatCompanyBeneficiaryToBeneficiaryFormWithEmailInput = (
  beneficiary: CompanyLegalBeneficiary | CompanySupposedBeneficiary | null,
): DefaultValues<BeneficiarySchemaWithEmail> => {
  return {
    ...formatCompanyBeneficiaryToBeneficiaryFormInput(beneficiary),
    inviteeEmail:
      beneficiary &&
      hasInvitation(beneficiary) &&
      beneficiary?.invitation?.inviteeEmail
        ? beneficiary?.invitation?.inviteeEmail
        : '',
  };
};
